/* eslint-disable import/no-anonymous-default-export */
import axiosInstance from "../axios/axios-configuration";
import { CancelToken } from "axios";
import { IRiferimentiSeguitiProtocollo } from "../shared/interfaces";

const controller = 'ProtocolReferences';



const getRiferimentiSeguitiProtocollo = (aooId: number, uorId: number | undefined, protocolId: number, cancelToken?: CancelToken): Promise<IRiferimentiSeguitiProtocollo> => {
    return axiosInstance.get(`${controller}/${aooId}/GetRiferimentiSeguitiProtocollo/${protocolId}`, { params: { uorId: uorId }, cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const createReference = (aooId: number, uorId: number, protocolId: number, referenceId: number,cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.post(`${controller}/${aooId}/${uorId}/CreateReference`, null, { params: { protocolId, referenceId }, cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const deleteReference = (aooId: number, uorId: number, protocolId: number, referenceId: number, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.delete(`${controller}/${aooId}/${uorId}/DeleteReference`, { params: { protocolId, referenceId }, cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}


export default {
    getRiferimentiSeguitiProtocollo,
    createReference,
    deleteReference
}